import { render, staticRenderFns } from "./WorkshopView.vue?vue&type=template&id=d5cf278c&"
import script from "./WorkshopView.vue?vue&type=script&lang=js&"
export * from "./WorkshopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports